var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role"},[_c('div',{staticClass:"open-wrap"},[_c('new-Insert',{attrs:{"type":"insert","clearData":_vm.clearData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }